import React from "react";
import KopSurat from "./KopSurat";

const fmt = (n) => "Rp " + (n || 0).toLocaleString("id-ID", { maximumFractionDigits: 0 });
const tgl = (iso) => {
  if (!iso) return "-";
  const [y, m, d] = iso.split("-");
  const bln = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];
  return `${parseInt(d, 10)} ${bln[parseInt(m, 10) - 1]} ${y}`;
};

const terbilang = (n) => {
  if (!n || n < 0) return "Nol";
  const sat = ["", "Satu", "Dua", "Tiga", "Empat", "Lima", "Enam", "Tujuh", "Delapan", "Sembilan", "Sepuluh", "Sebelas"];
  function r(num) {
    num = Math.floor(num);
    if (num < 12) return sat[num];
    if (num < 20) return r(num - 10) + " Belas";
    if (num < 100) return r(Math.floor(num / 10)) + " Puluh " + r(num % 10);
    if (num < 200) return "Seratus " + r(num - 100);
    if (num < 1000) return r(Math.floor(num / 100)) + " Ratus " + r(num % 100);
    if (num < 2000) return "Seribu " + r(num - 1000);
    if (num < 1000000) return r(Math.floor(num / 1000)) + " Ribu " + r(num % 1000);
    if (num < 1000000000) return r(Math.floor(num / 1000000)) + " Juta " + r(num % 1000000);
    return r(Math.floor(num / 1000000000)) + " Milyar " + r(num % 1000000000);
  }
  return r(n).replace(/\s+/g, " ").trim();
};

// Each page uses inline KopSurat at top
function Page({ children, last }) {
  return (
    <div className="pkwt-page" style={{
      pageBreakAfter: last ? "auto" : "always",
      breakAfter: last ? "auto" : "page",
      padding: "8mm 16mm 12mm 16mm",
      background: "white",
      fontFamily: "Times New Roman, serif",
      color: "#000",
      lineHeight: 1.5,
      minHeight: "1000px",
    }}>
      <KopSurat />
      {children}
    </div>
  );
}

export default function ContractDocument({ data }) {
  if (!data) return null;
  const emp = data.employee || {};
  const isSigned = data.status === "Aktif" || data.status === "Diperpanjang" || data.status === "Terminated";

  // Parse tugas into list items (split by newline)
  const tugasItems = (data.isi_tugas || "").split("\n").map((t) => t.trim()).filter(Boolean);

  return (
    <div className="slip-print pkwt-doc" style={{ background: "#909090", padding: "20px 0" }}>
      {/* ===== Page 1 ===== */}
      <Page>
        <h2 style={titleStyle}>SURAT PERJANJIAN KONTRAK KERJA</h2>
        <div style={{ textAlign: "center", fontSize: 12, marginBottom: 14 }}>
          Nomor: <strong>{data.nomor_kontrak}</strong>
        </div>

        <p style={pStyle}>Yang bertanda tangan di bawah ini:</p>
        <table style={{ fontSize: 12, marginBottom: 8 }}>
          <tbody>
            <tr><td style={tdLbl}>Nama</td><td>: <strong>{data.ceo_nama}</strong></td></tr>
            <tr><td style={tdLbl}>Jabatan</td><td>: {data.ceo_jabatan}</td></tr>
            <tr><td style={tdLbl}>Alamat</td><td>: {data.ceo_alamat}</td></tr>
          </tbody>
        </table>
        <p style={pStyle}>
          Dalam hal ini bertindak atas nama Pimpinan PT. FIVEHOSTER KARYA BANGSA yang berkedudukan di Jl. Sawah Lunto RT.27 RW.07 Desa Jeru Kec.Turen Kab.Malang dan selanjutnya disebut <strong>PIHAK PERTAMA</strong>.
        </p>

        <table style={{ fontSize: 12, marginBottom: 8, marginTop: 10 }}>
          <tbody>
            <tr><td style={tdLbl}>Nama</td><td>: <strong>{emp.nama_lengkap}</strong></td></tr>
            <tr><td style={tdLbl}>Tempat dan tanggal lahir</td><td>: {emp.tempat_lahir}, {tgl(emp.tanggal_lahir)}</td></tr>
            <tr><td style={tdLbl}>Pendidikan terakhir</td><td>: {emp.pendidikan || "-"}</td></tr>
            <tr><td style={tdLbl}>Jenis kelamin</td><td>: {emp.jenis_kelamin || "-"}</td></tr>
            <tr><td style={tdLbl}>Agama</td><td>: {emp.agama || "-"}</td></tr>
            <tr><td style={tdLbl}>Alamat</td><td>: {emp.alamat || "-"}</td></tr>
            <tr><td style={tdLbl}>Telepon</td><td>: {emp.no_hp || "-"}</td></tr>
          </tbody>
        </table>
        <p style={pStyle}>
          Dalam hal ini bertindak untuk dan atas nama diri pribadi dan selanjutnya disebut <strong>PIHAK KEDUA</strong>.
        </p>

        <h3 style={pasalH}>PASAL 1<br />KONTRAK KERJA</h3>
        <p style={ayatH}>Ayat 1</p>
        <p style={pStyle}>
          PIHAK PERTAMA menyatakan menerima PIHAK KEDUA sebagai pegawai kontrak (waktu tertentu) di PT. FIVEHOSTER KARYA BANGSA yang berkedudukan di Jl. Sawah Lunto RT.27 RW.07 Desa Jeru Kec. Turen Kab.Malang dan PIHAK KEDUA dengan ini menyatakan kesediaannya.
        </p>
        <p style={ayatH}>Ayat 2</p>
        <p style={pStyle}>
          Perjanjian kerja ini berlaku untuk jangka waktu <strong>{data.durasi_text}</strong>, terhitung sejak tanggal <strong>{tgl(data.tanggal_mulai)}</strong> dan berakhir pada tanggal <strong>{tgl(data.tanggal_selesai)}</strong>.
        </p>
        <p style={ayatH}>Ayat 3</p>
        <p style={pStyle}>
          Selama jangka waktu tersebut PIHAK KEDUA tidak dapat memutuskan hubungan kerja dan berkewajiban menyelesaikan pekerjaan sesuai dengan kontrak kerja.
        </p>

        <h3 style={pasalH}>PASAL 2</h3>
        <p style={ayatH}>Ayat 1</p>
        <p style={pStyle}>PIHAK KEDUA menyatakan kesediaannya untuk mematuhi serta mentaati seluruh peraturan tata tertib yang telah ditetapkan PIHAK PERTAMA selaku Pimpinan Perusahaan.</p>
        <p style={ayatH}>Ayat 2</p>
        <p style={pStyle}>Pelanggaran terhadap peraturan-peraturan tersebut di atas dapat mengakibatkan PIHAK KEDUA dijatuhi:</p>
        <ol style={olStyle}>
          <li style={liStyle}>Teguran, atau</li>
          <li style={liStyle}>Pemutusan Hubungan Kontrak, atau</li>
          <li style={liStyle}>Hukuman dalam bentuk lain dengan merujuk kepada Peraturan Negara yang mengaturnya.</li>
        </ol>
      </Page>

      {/* ===== Page 2 ===== */}
      <Page>
        <h3 style={pasalH}>PASAL 3<br />JAM KERJA</h3>
        <p style={ayatH}>Ayat 1</p>
        <ul style={ulStyle}>
          <li style={liStyle}>Jam izin terlambat masuk baik izin maupun tanpa izin maksimal 2 Jam</li>
          <li style={liStyle}>Harap sudah berada di tempat kerja 15 Menit sebelum jam pekerjaan dimulai</li>
          <li style={liStyle}>Hari libur nasional/agama tetap masuk atau mengikuti instruksi pimpinan</li>
        </ul>
        <p style={ayatH}>Ayat 2</p>
        <p style={pStyle}>
          Hari kerja mengikuti hari kerja Perusahaan yaitu <strong>{data.hari_kerja}</strong>. Jam masuk dan jam pulang yaitu <strong>{data.jam_kerja}</strong>. Hari Minggu Opsional. Apabila pegawai terlambat masuk kerja pada waktu yang telah ditentukan maka terdapat sanksi berupa:
        </p>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 11, marginTop: 6, marginBottom: 6 }}>
          <thead>
            <tr style={{ background: "#f0f0f0" }}>
              <th style={thStyle}>NO</th>
              <th style={thStyle}>WAKTU TERLAMBAT</th>
              <th style={thStyle}>SANKSI</th>
              <th style={thStyle}>KET</th>
            </tr>
          </thead>
          <tbody>
            <tr><td style={tdC}>1</td><td style={tdS}>&lt; 15 Menit</td><td style={tdS}>Toleransi</td><td style={tdS}></td></tr>
            <tr><td style={tdC}>2</td><td style={tdS}>&gt; 15 Menit</td><td style={tdS}>Potong Gaji 1 Jam</td><td style={tdS}></td></tr>
            <tr><td style={tdC}>3</td><td style={tdS}>&gt; 1 Jam</td><td style={tdS}>Potong Gaji 2 Jam</td><td style={tdS}></td></tr>
            <tr><td style={tdC}>4</td><td style={tdS}>&gt; 1½ Jam</td><td style={tdS}>Tidak Diperbolehkan Masuk Kerja</td><td style={tdS}></td></tr>
          </tbody>
        </table>
        <p style={ayatH}>Ayat 3</p>
        <p style={pStyle}>PIHAK KEDUA diperbolehkan melanjutkan pekerjaan perusahaan di luar hari dan jam kerja yang sudah ditentukan sesuai arahan dan izin dari Pimpinan dan setingkatnya yang berwenang.</p>

        <h3 style={pasalH}>PASAL 4<br />PENEMPATAN, TUGAS, DAN TANGGUNG JAWAB</h3>
        <p style={ayatH}>Ayat 1</p>
        <p style={pStyle}>
          PIHAK KEDUA akan bekerja sebagai <strong>{data.posisi}</strong> dan berkantor di PT. FIVEHOSTER KARYA BANGSA Jl. Sawah Lunto RT.27 RW.07 Desa Jeru Kec.Turen Kab.Malang.
        </p>
        <p style={ayatH}>Ayat 2</p>
        <p style={pStyle}>Tugas dan tanggung jawab PIHAK KEDUA adalah sebagai berikut:</p>
        {tugasItems.length > 0 ? (
          <ol style={olStyle}>
            {tugasItems.map((t, i) => <li key={i} style={{...liStyle, whiteSpace: "pre-wrap"}}>{t}</li>)}
          </ol>
        ) : (
          <p style={{ ...pStyle, fontStyle: "italic", color: "#888" }}>(Tugas belum diisi oleh admin)</p>
        )}

        <h3 style={pasalH}>PASAL 5<br />PERPANJANGAN MASA KONTRAK KERJA</h3>
        <p style={ayatH}>Ayat 1</p>
        <p style={pStyle}>Setelah berakhirnya jangka waktu tersebut, apabila masih diperlukan dilaksanakan lagi kegiatan kerjasama, maka perjanjian kerja ini dapat diperpanjang jika PIHAK PERTAMA dan PIHAK KEDUA sepakat untuk melanjutkan kontrak.</p>

        <h3 style={pasalH}>PASAL 6<br />GAJI DAN CARA PEMBAYARAN</h3>
        <p style={ayatH}>Ayat 1</p>
        <p style={pStyle}>
          PIHAK PERTAMA akan memberikan gaji kepada PIHAK KEDUA sesuai peraturan Perusahaan yang mengatur mengenai Upah Minimum Kerja di tahun tersebut <strong>({fmt(data.gaji_pokok)})</strong> ({data.gaji_terbilang || terbilang(data.gaji_pokok)} Rupiah).
        </p>
        <p style={ayatH}>Ayat 2</p>
        <p style={pStyle}>
          Pembayaran gaji dan insentif akan diberikan melalui {emp.metode_gaji === "Cash" ? "tunai (cash)" : `transfer bank ${emp.bank_nama || ""} ${emp.bank_rekening ? `(No. Rek: ${emp.bank_rekening} a.n. ${emp.bank_atas_nama})` : ""}`} pada tanggal <strong>17</strong> setiap bulannya.
        </p>
        
        {data.tunjangan_detail && data.tunjangan_detail.length > 0 && (
          <>
            <p style={ayatH}>Ayat 3</p>
            <p style={pStyle}>Selain gaji pokok, PIHAK KEDUA berhak menerima tunjangan sebagai berikut:</p>
            <ul style={ulStyle}>
              {data.tunjangan_detail.map((t, i) => (
                <li key={i} style={liStyle}>
                  <strong>{t.nama}</strong> ({t.jenis}): {fmt(t.nominal)} {t.periode ? `per ${t.periode}` : ""}
                </li>
              ))}
            </ul>
            <p style={pStyle}>Total tunjangan adalah <strong>{fmt(data.tunjangan_detail.reduce((sum, t) => sum + (t.nominal || 0), 0))}</strong> dengan periode pembayaran sesuai jenis tunjangan masing-masing.</p>
          </>
        )}
      </Page>

      {/* ===== Page 3 ===== */}
      <Page>
        <h3 style={pasalH}>PASAL 7<br />LEMBUR</h3>
        <p style={ayatH}>Ayat 1</p>
        <p style={pStyle}>PIHAK KEDUA diharuskan masuk kerja lembur jika pekerjaan yang menjadi tanggung jawab harus segera diselesaikan atau bersifat mendesak (urgent).</p>

        <h3 style={pasalH}>PASAL 8<br />IZIN</h3>
        <p style={ayatH}>Ayat 1</p>
        <p style={pStyle}>PIHAK KEDUA boleh mengajukan izin tidak masuk kerja apabila memang terdapat alasan yang tidak bisa ditinggalkan, namun tugas yang menjadi tanggung jawab pekerjaannya tetap diselesaikan sesuai dengan target.</p>
        <p style={ayatH}>Ayat 2</p>
        <ol style={olStyle}>
          <li style={liStyle}>Pengajuan izin diajukan paling lambat 2 (dua) hari sebelum hari izin.</li>
          <li style={liStyle}>Apabila terdapat kejadian yang mendesak seperti sakit, kecelakaan, kerabat meninggal dunia, dan lain sebagainya maka akan diberikan kompensasi pengajuan izin mendadak maksimal 1 kali dalam 1 bulan (tidak berlaku akumulasi).</li>
          <li style={liStyle}>Apabila terdapat kejadian yang mendesak seperti sakit harus dibuktikan dengan Surat Keterangan Sakit dari Dokter dan tetap akan mendapat Hak Gaji pada bulan tersebut.</li>
        </ol>
        <p style={ayatH}>Ayat 3</p>
        <p style={pStyle}>Apabila PIHAK KEDUA telah melakukan izin tidak masuk kerja tanpa alasan sebanyak lebih dari 2 kali dalam satu bulan, maka akan mendapat Teguran sampai dengan sanksi berupa SP 1 dan seterusnya.</p>

        <h3 style={pasalH}>PASAL 9<br />KERJA RANGKAP</h3>
        <p style={ayatH}>Ayat 1</p>
        <p style={pStyle}>Selama masa kontrak PIHAK KEDUA dilarang melakukan rangkap kerja di instansi atau perusahaan lain yang bisa mengganggu kinerja serta profesionalisme pegawai terkecuali seizin atasan dan didasarkan oleh hak-hak yang tidak mengikat.</p>

        <h3 style={pasalH}>PASAL 10<br />PEMUTUSAN KONTRAK KERJA</h3>
        <p style={ayatH}>Ayat 1</p>
        <p style={pStyle}>Dengan memperhatikan Perjanjian Kontrak Kerja ini, PIHAK PERTAMA dapat mengakhiri hubungan kerja dengan PIHAK KEDUA karena pengingkaran perjanjian ini.</p>
        <p style={ayatH}>Ayat 2</p>
        <p style={pStyle}>Jika terjadi Pemutusan Kontrak Kerja, maka PIHAK KEDUA:</p>
        <ol style={olStyle}>
          <li style={liStyle}>Tidak akan mendapatkan Upah di bulan berjalan.</li>
          <li style={liStyle}>Harus menyelesaikan pekerjaan yang sedang dikerjakan sesuai dengan pertimbangan pada saat pemutusan kontrak kerja.</li>
          <li style={liStyle}>Wajib mengembalikan semua inventaris Perusahaan yang digunakan bila ada.</li>
        </ol>
      </Page>

      {/* ===== Page 4 (Penutup + TTD) ===== */}
      <Page last>
        <h3 style={pasalH}>PASAL 11<br />BERAKHIRNYA PERJANJIAN</h3>
        <p style={pStyle}>Kontrak kerja ini akan berakhir dengan sendirinya jika PIHAK KEDUA:</p>
        <ol style={olStyle}>
          <li style={liStyle}>Diberhentikan.</li>
          <li style={liStyle}>Berakhir masa kontrak.</li>
          <li style={liStyle}>Meninggal dunia.</li>
        </ol>

        <h3 style={pasalH}>PASAL 12<br />KEADAAN DARURAT (FORCE MAJEUR)</h3>
        <p style={pStyle}>Perjanjian kerja ini batal dengan sendirinya jika karena keadaan atau situasi yang memaksa, seperti: bencana alam, pemberontakan, perang, huru-hara, kerusuhan, Peraturan Pemerintah atau apapun yang mengakibatkan perjanjian kerja ini tidak mungkin lagi untuk diwujudkan.</p>

        <h3 style={pasalH}>PASAL 13<br />PENYELESAIAN PERSELISIHAN</h3>
        <p style={ayatH}>Ayat 1</p>
        <p style={pStyle}>Apabila terjadi perselisihan antara kedua belah pihak, akan diselesaikan secara musyawarah untuk mencapai mufakat.</p>
        <p style={ayatH}>Ayat 2</p>
        <p style={pStyle}>Apabila dengan cara ayat 1 pasal ini tidak tercapai kata sepakat, maka kedua belah pihak sepakat untuk menyelesaikan permasalahan tersebut dilakukan melalui prosedur hukum, dengan memilih kedudukan hukum di Kantor Pengadilan Tinggi Negeri Kabupaten Malang.</p>

        {data.isi_pasal_tambahan && (
          <>
            <h3 style={pasalH}>PASAL TAMBAHAN</h3>
            <p style={{ ...pStyle, whiteSpace: "pre-wrap" }}>{data.isi_pasal_tambahan}</p>
          </>
        )}

        <h3 style={pasalH}>PASAL 14<br />PENUTUP</h3>
        <p style={pStyle}>Demikianlah perjanjian ini dibuat, disetujui, dan ditandatangani dalam rangkap dua, asli dan tembusan bermaterai cukup dan berkekuatan hukum yang sama. Satu dipegang oleh PIHAK PERTAMA dan lainnya untuk PIHAK KEDUA.</p>

        <p style={{ ...pStyle, marginTop: 12 }}>
          Dibuat di : <strong>{data.tempat_pembuatan}</strong><br />
          Tanggal : <strong>{tgl(data.tanggal_dibuat?.slice(0, 10) || data.tanggal_mulai)}</strong>
        </p>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 60, marginTop: 30, fontSize: 12, textAlign: "center" }}>
          <div>
            <div style={{ fontWeight: 700 }}>PIHAK PERTAMA</div>
            <div style={{ height: 110, display: "flex", alignItems: "center", justifyContent: "center", color: "#999", fontStyle: "italic" }}>
              (tanda tangan &amp; stempel)
            </div>
            <div style={{ borderTop: "1px solid #000", paddingTop: 4 }}>
              <strong>[ {data.ceo_nama} ]</strong>
            </div>
          </div>
          <div>
            <div style={{ fontWeight: 700 }}>PIHAK KEDUA</div>
            <div style={{ height: 110, display: "flex", alignItems: "center", justifyContent: "center" }}>
              {isSigned && data.signature_data ? (
                <img src={data.signature_data} alt="ttd" style={{ maxHeight: 110, maxWidth: "100%" }} />
              ) : (
                <span style={{ color: "#999", fontStyle: "italic" }}>(belum ditandatangani)</span>
              )}
            </div>
            <div style={{ borderTop: "1px solid #000", paddingTop: 4 }}>
              <strong>[ {emp.nama_lengkap} ]</strong>
              {data.tanggal_ditandatangani && (
                <div style={{ fontSize: 10, color: "#666" }}>Ditandatangani: {tgl(data.tanggal_ditandatangani)}</div>
              )}
            </div>
          </div>
        </div>

        {data.status === "Terminated" && (
          <div style={{ marginTop: 16, padding: 10, background: "#ffbaba", border: "2px solid #d8000c", color: "#d8000c", textAlign: "center", fontSize: 12 }}>
            <strong>KONTRAK DIBERHENTIKAN</strong> pada {tgl(data.tanggal_terminated)}<br />
            Alasan: {data.alasan_terminated}
          </div>
        )}
      </Page>
    </div>
  );
}

const titleStyle = { textAlign: "center", fontSize: 14, fontWeight: 700, textDecoration: "underline", marginTop: 6, marginBottom: 6 };
const pasalH = { fontSize: 12.5, fontWeight: 700, marginTop: 12, marginBottom: 4, textAlign: "center", lineHeight: 1.25 };
const ayatH = { fontSize: 11.5, fontWeight: 700, fontStyle: "italic", margin: "6px 0 2px 0" };
const pStyle = { fontSize: 11.5, textAlign: "justify", margin: "0 0 4px 0", lineHeight: 1.5 };
const tdLbl = { width: 170, paddingRight: 6, verticalAlign: "top", fontSize: 11.5 };
const thStyle = { border: "1px solid #000", padding: 4, textAlign: "center", fontSize: 11, fontWeight: 700 };
const tdC = { border: "1px solid #000", padding: 4, textAlign: "center", width: 30, fontSize: 11 };
const tdS = { border: "1px solid #000", padding: 4, fontSize: 11 };
const olStyle = { fontSize: 12, marginLeft: 24, marginTop: 4, marginBottom: 4, lineHeight: 1.6, listStylePosition: "inside", paddingLeft: 0 };
const ulStyle = { fontSize: 12, marginLeft: 18, marginTop: 4, marginBottom: 4, lineHeight: 1.6, listStylePosition: "inside", paddingLeft: 0 };
const liStyle = { marginBottom: 4, marginLeft: 0, whiteSpace: "normal", textAlign: "justify" };
